import set from "date-fns/set";

export const HeadCells = [
  {
    field: "sender_name",
    headerTitle: "Name",
  },
  {
    field: "sender_email",
    headerTitle: "Email",
  },
  {
    field: "subject",
    headerTitle: "Subject",
  },
  {
    field: "message",
    headerTitle: "message",
  },
  {
    field: "status",
    headerTitle: "Status",
  },
  // {
  //   field: "created_at",
  //   headerTitle: "Date and Time",
  // },
];

export const QueryRecord = [
  {
    id: 1,
    name: "Abdullah",
    email: "abd@gmail.com",
    subject: "Trading hour for Bot",
    message: "Is this bot trade 24/7??",
    createdAt: set(new Date(), { hours: 1, minutes: 30 })
      .toString()
      .slice(0, 21),
    isUnRead: true,
    status: "Not Responded",
  },
  {
    id: 2,
    name: "Nawaz",
    email: "nawaz@gmail.com",
    subject: "Trading hour for Bot",
    message: "Is this bot trade 24/7??",
    createdAt: set(new Date(), { hours: 2, minutes: 30 })
      .toString()
      .slice(0, 21),
    isUnRead: false,
    status: "Not Responded",
  },
  {
    id: 3,
    name: "Arslan",
    email: "arslan@gmail.com",
    subject: "Trading hour for Bot",
    message: "Is this bot trade 24/7??",
    createdAt: set(new Date(), { hours: 3, minutes: 30 })
      .toString()
      .slice(0, 21),
    isUnRead: false,
    status: "Responded",
  },
  {
    id: 4,
    name: "Hamza",
    email: "abd@gmail.com",
    subject: "How to get Bot",
    message: "How to get Bot?",
    createdAt: set(new Date(), { hours: 4, minutes: 30 })
      .toString()
      .slice(0, 21),
    isUnRead: true,
    status: "Not Responded",
  },
  {
    id: 5,
    name: "Nawaz",
    email: "nawaz@gmail.com",
    subject: "Trading hour for Bot",
    message: "Is this bot trade 24/7??",
    createdAt: set(new Date(), { hours: 5, minutes: 30 })
      .toString()
      .slice(0, 21),
    isUnRead: false,
    status: "Not Responded",
  },
  {
    id: 6,
    name: "Arslan",
    email: "arslan@gmail.com",
    subject: "Trading hour for Bot",
    message: "Is this bot trade 24/7??",
    createdAt: set(new Date(), { hours: 7, minutes: 30 })
      .toString()
      .slice(0, 21),
    isUnRead: false,
    status: "Responded",
  },
];

export const getQueryInfoByID = (id) => {
  if (id != 0) return QueryRecord.find((record) => record.id === id);
  else return null;
};
